import { Text } from "@chakra-ui/react";
import { Box, Flex } from "@chakra-ui/layout";
import { Tag } from "@chakra-ui/tag";
import {
  ProcuracaoDetalheLog,
  StatusProcuracaoEnum,
} from "core/features/assembleia/typings/procuracao";
import colors from "core/resources/theme/colors";
import { formatDateOntemHoje } from "infra/helpers/formatDateOntemHoje";
import {
  getTagColorSchemeForStatus,
  getTagVariantForStatus,
} from "../../ListaProcuracoes/util";
import moment from "moment";

interface HistoricoProps {
  logs: ProcuracaoDetalheLog[];
}

function Historico({ logs }: HistoricoProps) {
  return (
    <Flex flexDir="column">
      <Text fontSize={20} mb={1}>
        Histórico
      </Text>
      {logs.map((log, index) => (
        <HistoricoItem log={log} key={index} />
      ))}
    </Flex>
  );
}

const HistoricoItem = ({ log }: { log: ProcuracaoDetalheLog }) => (
  <Flex flexDir="column">
    <Flex gridGap={4} alignItems="center">
      <Box
        rounded="full"
        borderColor={colors.blueishGray50}
        borderWidth={3}
        w="16px"
        h="16px"
      />
      <Text
        color={colors.blueishGray500}
        fontWeight="medium"
        fontStyle="italic"
      >
        {formatDateOntemHoje(log.createdAt, {
          dateFormat: "DD/MM/YYYY",
          alwaysShowYear: true,
        })}{" "}
        às {moment(log.createdAt).format("HH:mm")}
      </Text>
      <Tag
        rounded="full"
        px={4}
        py={2}
        colorScheme={getTagColorSchemeForStatus(log.status.id)}
        variant={getTagVariantForStatus(log.status.id)}
      >
        {log.status.id === StatusProcuracaoEnum.EmAnalise
          ? "Em análise"
          : log.status.nome}
      </Tag>
    </Flex>
    <Flex
      minH="40px"
      borderLeftWidth={2}
      borderLeftColor={colors.blueishGray50}
      pl={6}
      pt={2}
      flexDir="column"
      h="fit-content"
      ml="7.5px"
    >
      {log.observacao ? (
        <Box mb={4}>
          <HistoricoItemInfo titulo="MOTIVO:" texto={log.observacao} />
        </Box>
      ) : null}
      {log.pessoa ? (
        <Box mb={4}>
          <HistoricoItemInfo titulo="RESPONSÁVEL:" texto={log.pessoa.nome} />
        </Box>
      ) : null}
    </Flex>
  </Flex>
);

const HistoricoItemInfo = ({
  titulo,
  texto,
}: {
  titulo: string;
  texto: string;
}) => (
  <Flex flexDir="column">
    <Text color={colors.blueishGray500} fontSize={11} lineHeight="12px">
      {titulo}
    </Text>
    <Text color={colors.black} fontSize={12} lineHeight="12px">
      {texto}
    </Text>
  </Flex>
);

export default Historico;
